import { Auth } from "aws-amplify";
import { InitData } from "./../InitData";

async function fetchPostRequest(endpointName, body, signal) {
  let bodyRequest = !body ? {} : body;
  try {
    const fetchPost = await fetch(
      `${InitData.getInstance().getApiPrefix()}${endpointName}`,
      {
        method: "POST",
        headers: {
          Authorization: `${InitData.getInstance().getAuthorization()}`,
          apikey: `${InitData.getInstance().getApiKey()}`,
        },
        body: JSON.stringify(bodyRequest),
        signal: signal,
      }
    );
    const result = await fetchPost.json();
    return result;
  } catch (error) {
    console.log("Fetch Service - " + error);
    return error;
  }
}

async function fetchGetRequest(endpointName, signal) {
  try {
    const fetchGet = await fetch(
      `${InitData.getInstance().getApiPrefix()}${endpointName}`,
      {
        method: "GET",
        headers: {
          Authorization: `${InitData.getInstance().getAuthorization()}`,
          apikey: `${InitData.getInstance().getApiKey()}`,
        },
        signal: signal,
      }
    );
    const result = await fetchGet.json();
    return result;
  } catch (error) {
    console.log("Fetch Service - " + error);
    return error;
  }
}

function getCurrentAuthentication() {
  return new Promise(async (resolve, reject) => {
    Auth.currentSession()
      .then((session) => {
        var idTokenExpire = session.getIdToken().getExpiration();
        var refreshToken = session.getRefreshToken().token;
        var currentTimeSeconds = Math.round(+new Date() / 1000);
        if (idTokenExpire < currentTimeSeconds) {
          console.log(`Expired token`);
          const authorization = `Bearer ${refreshToken}`;
          InitData.getInstance().setAuthorization(authorization);
        } else {
          // console.log(
          //   `Should be good: `,
          //   InitData.getInstance().getAuthorization()
          // );
        }
        resolve(session);
      })
      .catch((error) => {
        console.log("AuthService.js - getCurrentAuth Error : ", error);
        reject(error);
      });
  });
}

export { fetchPostRequest, fetchGetRequest, getCurrentAuthentication };
